import { ApartmentOutlined } from '@material-ui/icons';
import React from 'react';
import Question from '../question/Question';
import {
  Box,
  Container,
  Card,
  CardContent,
  Grid,
  makeStyles,
  Typography,
  TextField,
} from '@material-ui/core';
import clsx from 'clsx';

const Radio = ({
  icon,
  label,
  width,
  height,
  index,
  name,
  selectedValue,
  handleChange,
  hovercolor,
}) => {
  const useStyles = makeStyles({
    card: {
      width: width || 150,
      height: height || 150,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      padding: '5px',
      marginLeft: '10px',
      marginRight: '10px',
      marginTop: '10px',
      marginBottom: '10px',

      '&:hover': {
        border:
          hovercolor == undefined
            ? '5px solid #1D85FE'
            : '5px solid ' + hovercolor,
        boxShadow: '0 9px 12px 0 rgba(0,0,0,.2)',
        transform: 'translateY(-2px)',
        padding: '0px',
      },
    },
    selectedCard: {
      border:
        hovercolor == undefined
          ? '5px solid #1D85FE'
          : '5px solid ' + hovercolor,
      boxShadow: '0 9px 12px 0 rgba(0,0,0,.2)',
      transform: 'translateY(-2px)',
      padding: '0px',
    },
  });
  const classes = useStyles();
  return (
    <>
      <input
        id={`radioQuestion-${index}`}
        type="radio"
        name={name}
        onChange={handleChange}
        style={{ display: 'none' }}
      />
      <label htmlFor={`radioQuestion-${index}`}>
        <Card
          className={clsx(
            classes.card,
            selectedValue != undefined && index === selectedValue
              ? classes.selectedCard
              : ''
          )}
          variant="outlined"
          hovercolor={hovercolor}
        >
          <CardContent hovercolor={hovercolor}>
            <div className="flex flex-col items-center text-center">
              <img width="80px" src={icon} />

              <Typography variant="body2">{label}</Typography>
            </div>
          </CardContent>
        </Card>
      </label>
    </>
  );
};

const RadioCardOther = ({
  daten,
  cardcontent,
  handleNext,
  url,
  handleUpdate,
  hovercolor,
}) => {
  let cardID =
    daten['chain'].length > 0
      ? daten['chain'][daten['chain'].length - 1].toString()
      : daten['chain'][0].toString();
  let step = daten['chain'].length;
  let selectedValue = undefined;
  try {
    selectedValue = daten['info'][cardID]['selection'];
  } catch (error) {
    //no catch
  }
  const handleChange = index => {
    cardID in daten['info'] ? 0 : (daten['info'][cardID] = {}); //Create Dict in Info if not exists
    daten['info'][cardID]['selection'] = index;
    if (index === 2) {
      daten['info'][cardID]['weiterButtonShow'] = true;
      handleUpdate(daten);
      return;
    }
    handleNext(daten);
  };

  const handleChangeReason = e => {
    daten['info'][cardID]['reason'] = e.target.value;
    daten['info'][cardID]['weiterButtonAllow'] = true;
    handleUpdate(daten);
  };

  let renderObjekt = (
    <div className="flex flex-wrap justify-center">
      <div className="ml-10px mr-10px mt-10px mb-10px">
        <Radio
          index={0}
          name={'radio' + 0}
          selectedValue={selectedValue}
          label={cardcontent['radiocard'][0]}
          handleChange={e => handleChange(0)}
          icon={url + cardcontent['images'][0]}
          width={cardcontent['radiocard'].length > 5 ? 180 : 150}
          height={cardcontent['radiocard'].length > 5 ? 120 : 150}
          hovercolor={hovercolor}
        />
      </div>
      <div className="ml-10px mr-10px mt-10px mb-10px">
        <Radio
          index={1}
          name={'radio' + 1}
          selectedValue={selectedValue}
          label={cardcontent['radiocard'][1]}
          handleChange={e => handleChange(1)}
          icon={url + cardcontent['images'][1]}
          width={cardcontent['radiocard'].length > 5 ? 180 : 150}
          height={cardcontent['radiocard'].length > 5 ? 120 : 150}
          hovercolor={hovercolor}
        />
      </div>
      <div className="ml-10px mr-10px mt-10px mb-10px">
        <Radio
          index={2}
          name={'radio' + 2}
          selectedValue={selectedValue}
          label={cardcontent['radiocard'][2]}
          handleChange={e => handleChange(2)}
          icon={url + cardcontent['images'][2]}
          width={cardcontent['radiocard'].length > 5 ? 180 : 150}
          height={cardcontent['radiocard'].length > 5 ? 120 : 150}
          hovercolor={hovercolor}
        />
      </div>
    </div>
  );

  return (
    <div className="h-full flex flex-col justify-between " id="radiocardother">
      <div className="text-center mt-10px">
        <Question questionNo={step} questionText={cardcontent['headline']} />
      </div>
      <div className="flex flex-col justify-center">
        <div>{renderObjekt}</div>
        <div
          className={
            daten['info'][cardID]['weiterButtonShow']
              ? 'flex justify-center mt-40px'
              : 'hidden'
          }
        >
          <TextField
            InputProps={{
              style: {
                width: '190px',
              },
            }}
            id="reason"
            name="reason"
            label="Grund"
            value={
              daten['info'][cardID]['reason']
                ? daten['info'][cardID]['reason']
                : ''
            }
            onChange={handleChangeReason}
          ></TextField>
        </div>
      </div>

      <div className="h-40px"></div>
    </div>
  );
};

export default RadioCardOther;
